import { render } from "./collaboratori.vue?vue&type=template&id=1aca6848&ts=true"
import script from "./collaboratori.vue?vue&type=script&lang=ts"
export * from "./collaboratori.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__